<div>
  @if (mandatory === true) {
    <div style="color: red">(*)</div>
  }
  <div>{{ caption }}</div>
</div>
<div>
  <dx-select-box
    [dataSource]="dataSource"
    [(value)]="entityValue"
    displayExpr="name"
    [searchEnabled]="true"
    [searchTimeout]="750"
    [showClearButton]="true"
    (onOpened)="onOpened()"
    [disabled]="isDisabled">
    <dx-validator>
      @if (mandatory === true) {
        <dxi-validation-rule type="required" message="{{ 'FIELD_IS_REQUIRED' | translate }}"></dxi-validation-rule>
      }
    </dx-validator>
  </dx-select-box>
</div>
